import { copyToClipboard } from "./utils";

document.addEventListener("DOMContentLoaded", function () {
  const articleContent = document.querySelector(".article-content");
  const snippetWrap = document.querySelector(".snippet-wrap");
  const snippetShareModal = document.getElementById("snippet-share-modal");
  const buttonCopy = document.querySelector(".button-copy");
  const buttonCopyCitation = document.querySelector(".button-copy-citation");

  if (articleContent) {
    articleContent.addEventListener("mouseup", function (e) {
      if (snippetWrap.classList.contains("active")) {
        snippetWrap.classList.remove("active");
      }

      var selection = window.getSelection();

      var text = selection.toString().trim();
      if ("" == text) {
        return;
      }

      snippetWrap.classList.add("active");
      snippetWrap.style.left = e.pageX + "px";
      snippetWrap.style.top = e.pageY + "px";

      snippetShareModal.querySelector(
        ".selected-snippet"
      ).innerHTML = `"${text}"`;

      // Facebook.
      var facebookURL = new URL(
        snippetShareModal.querySelector(".icon-facebook").getAttribute("href")
      );
      facebookURL.searchParams.set("quote", text);
      snippetShareModal
        .querySelector(".icon-facebook")
        .setAttribute("href", facebookURL.toString());

      // Twitter.
      var twitterURL = new URL(
        snippetShareModal.querySelector(".icon-twitter").getAttribute("href")
      );
      twitterURL.searchParams.set("text", text);
      snippetShareModal
        .querySelector(".icon-twitter")
        .setAttribute("href", twitterURL.toString());

      // Email.
      var emailURL = new URL(
        snippetShareModal.querySelector(".icon-email").getAttribute("href")
      );
      var currentURL = emailURL.searchParams.get("body");
      emailURL.searchParams.set("body", text + " " + currentURL);
      snippetShareModal
        .querySelector(".icon-email")
        .setAttribute("href", emailURL.toString());

      buttonCopy.addEventListener("click", function () {
        copyToClipboard(text);
        snippetWrap.classList.remove("active");
      });

      buttonCopyCitation.addEventListener("click", function () {
        var elem = document.querySelector(
          ".article-main .citation .citation-style.active p"
        );

        var citeText = elem.textContent;

        var citeString = `${text}
				${citeText}`;

        copyToClipboard(citeString);
        snippetWrap.classList.remove("active");
      });
    });
  }
});
